export { default as Memorandum } from "./Memorandum";
